import React        from 'react';
//import ReactDOM     from 'react-dom';
import RoutesApp    from './routes';
import { createRoot } from "react-dom/client";
//ReactDOM.render( <React.StrictMode><RoutesApp/></React.StrictMode>, document.getElementById('root') );

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
      root.render(<RoutesApp/>);
